/****************************************************
* Module Name:  AddMfgProcessModal.js
* Project:      Pansuriya Impex Sales & Manufacturing
* Owner:        info@pansuriyaimpex.com
*
* Copyright (c) Pansuriya Impex
* All rights reserved.
****************************************************/
import ProcessMasterProxy from "../../utility/proxy/manager/manufacturingProxy/processMasterProxy";
import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import CircularProgress from "@mui/material/CircularProgress";
import RefreshOutlinedIcon from "@mui/icons-material/RefreshOutlined";
import Constants from "../../utility/constants";
import Select from "react-select";
import "bootstrap/dist/css/bootstrap.min.css";
import { Box, Button, TextField, Tooltip } from "@mui/material";
import Utility from "../../utility/utility";
import CommonSnackbar from "../common/commonSnackBar";
import { LoadingButton } from "@mui/lab";
import logo from '../../images/pansuriya.jpg'
import SaveIcon from '@mui/icons-material/Save';

const setPropSourceData = (dataToMap) => {
    let newArr = [];
    dataToMap.map((item) => {
        let option = { value: item.id, label: item.name };
        newArr.push(option);
        return true;
    });
    return newArr;
};

const AddMfgProcessModal = ({
    Show,
    handleClose,
    handleSave,
    loading,
    editOperation,
    sourceData,
}) => {

    const [showError, setShowError] = React.useState(false);
    const [newProcessName, setNewProcessName] = useState(editOperation ? sourceData.processname : "");
    const [newDescription, setNewDescription] = useState(editOperation ? sourceData.description : "");
    const [nextProcess, setNextProcess] = useState(editOperation ? setPropSourceData(sourceData.nextprocess) : []);
    const [validateProcessPresentSpinner, setValidateProcessPresentSpinner] = useState(false);
    const [processAvailable, setProcessAvailable] = useState(true);
    const [showValidationMessage, setShowValidationMessage] = useState(false);
    const [processValidationError, setProcessValidationError] = useState("");
    const [showProcessGroupLoadSpinner, setShowProcessGroupLoadSpinner] = useState(false);
    const [processOptions, setProcessOptions] = useState([]);

    useEffect(() => {
        getAllProcessGroup();
    }, [])

    const closeErrorDialog = () => {
        setShowError(false);
    };

    const validateProcessPresent = (processEntered) => {
        if (!processEntered || processEntered.trim() === "") return;

        setValidateProcessPresentSpinner(true);

        ProcessMasterProxy.CheckProcessAvailable(processEntered, (response) => {
            //if we got response that means department is present at backend
            if (response) {
                //DepartmentName already present
                setValidateProcessPresentSpinner(false);
                setShowValidationMessage(true);
                setProcessAvailable(false);
            } else {
                //DepartmentName not available, so can be used
                setValidateProcessPresentSpinner(false);
                setShowValidationMessage(true);
                setProcessAvailable(true);
            }
        });
    };

    const getAllProcessGroup = () => {
        setShowProcessGroupLoadSpinner(true);
        ProcessMasterProxy.GetAllProcess((response) => {
            setAllProcessGroupData(response);
            setShowProcessGroupLoadSpinner(false);
        }
        );
    }

    const setAllProcessGroupData = (response) => {
        let optionsArray = [];
        response.map((data) => {
            let option = { value: data.id, label: data.name };
            optionsArray.push(option);
            return true;
        });

        setProcessOptions(optionsArray);
        setNextProcess(nextProcess.length > 0 ? nextProcess : optionsArray[0]);
    }

    const buttonDisable = () => {
        if (!editOperation) {
            return (
                !showValidationMessage ||
                !processAvailable
            );
        } else {
            return (
                newProcessName.length === 0 ||
                nextProcess.length === 0
            );
        }
    };

    const saveData = () => {
        let nextProcessIds = Array.isArray(nextProcess)
            ? nextProcess.map(i => i.value)
            : [nextProcess.value];

        let data = {
            id: editOperation ? sourceData.processid : undefined,
            name: newProcessName,
            description: newDescription,
            nextprocessid: nextProcessIds,
        };

        if (handleSave) {
            handleSave(data);
        }
    }

    return (
        <Box>
            <CommonSnackbar
                show={showError}
                message={
                    <Box>
                        Add Process validation Failed
                        <br /> Please enter complete data
                    </Box>
                }
                variant={"error"}
                autoHide={false}
                handleClose={closeErrorDialog}
                title="Validation Failure"
            />

            <Modal backdrop="static" show={Show} onHide={handleClose} enforceFocus={false} >
                <Modal.Header closeButton>
                    <Modal.Title>
                        <img
                            src={logo}
                            height="40pt"
                            width="40pt"
                            alt={Constants.COMPANY_SITE}
                        />
                        &nbsp;&nbsp;Add or Edit Process
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <center>
                        <table>
                            <tbody>
                                {editOperation && (
                                    <tr>
                                        <td>
                                            <Form.Label>Process Id</Form.Label>
                                        </td>
                                        <td>
                                            <Form.Label>
                                                {sourceData.processid}
                                            </Form.Label>
                                        </td>
                                    </tr>
                                )}
                                {(editOperation || !sourceData) && (
                                    <tr>
                                        <td>&nbsp;</td>
                                    </tr>
                                )}
                                <tr>
                                    <td style={{ width: "35%" }}>
                                        <Form.Label>
                                            Process Name
                                            <sup style={{ color: "red" }}>*</sup>
                                        </Form.Label>
                                    </td>
                                    {editOperation || !sourceData ? (
                                        <td>
                                            <Form.Label>{newProcessName}</Form.Label>
                                        </td>
                                    ) : (
                                        <td>
                                            <TextField
                                                margin="normal"
                                                fullWidth
                                                size="small"
                                                label="Process Name (required)"
                                                placeholder="Enter Process Name"
                                                value={newProcessName}
                                                autoFocus
                                                onBlur={(e) =>
                                                    validateProcessPresent(newProcessName)
                                                }
                                                onChange={(e) => {
                                                    setNewProcessName(e.target.value);
                                                    setShowValidationMessage(false);
                                                    setProcessValidationError(Utility.CheckIsPresent(
                                                        e.target.value
                                                    )
                                                        ? ""
                                                        : "Process Cannot be Empty");
                                                }
                                                }
                                                helperText={processValidationError}
                                                error={
                                                    processValidationError.length > 0
                                                }
                                            />
                                        </td>
                                    )}
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>
                                        {validateProcessPresentSpinner ? (
                                            <CircularProgress size="1rem" />
                                        ) : !showValidationMessage ? (
                                            <Box>&nbsp;</Box>
                                        ) : processAvailable ? (
                                            <font color="green">Process available</font>
                                        ) : (
                                            <font color="red">Process not available</font>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <Form.Label>Description</Form.Label>
                                    </td>
                                    <td>
                                        <TextField
                                            margin="normal"
                                            fullWidth
                                            size="small"
                                            label="Description"
                                            placeholder="Enter Description"
                                            value={newDescription}
                                            onChange={(e) =>
                                                setNewDescription(e.target.value)
                                            }
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                                <tr>
                                    <td>
                                        <Form.Label>Next Process</Form.Label>
                                    </td>
                                    <td style={{ width: "100%" }}>
                                        <Select menuPlacement="auto"
                                            blurInputOnSelect={false}
                                            className="basic-single"
                                            classNamePrefix="select"
                                            value={nextProcess}
                                            isMulti
                                            isSearchable={true}
                                            name="Department"
                                            styles={Constants.Styles}
                                            menuPortalTarget={document.body}
                                            options={processOptions}
                                            onChange={(selectedOption) => {
                                                setNextProcess(selectedOption);
                                            }}
                                        />
                                    </td>
                                    <td>
                                        {showProcessGroupLoadSpinner ? (
                                            <CircularProgress
                                                size="1em"
                                                sx={{ mt: 1.5, ml: 0.7 }}
                                            />
                                        ) : (
                                            <Tooltip title="Reload">
                                                <RefreshOutlinedIcon
                                                    color="primary"
                                                    fontSize="medium"
                                                    onClick={() => getAllProcessGroup()}
                                                    sx={{
                                                        cursor: "pointer",
                                                        mt: 1,
                                                    }}
                                                />
                                            </Tooltip>
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td>&nbsp;</td>
                                </tr>
                            </tbody>
                        </table>
                    </center>
                </Modal.Body>
                <Modal.Footer>
                    <LoadingButton
                        loading={loading}
                        loadingPosition="start"
                        startIcon={<SaveIcon />}
                        variant="contained"
                        onClick={() => saveData()}
                        disabled={buttonDisable()}
                        sx={{ mr: 1 }}
                    >
                        Save
                    </LoadingButton>
                    <Button
                        variant="contained"
                        color="error"
                        onClick={handleClose}
                        disabled={loading}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </Box>
    );

};

export default AddMfgProcessModal;